export const LIBRARY_NAME = '@/Api'
export const LIBRARY_VERSION = '0.2.0'

export const version = (): string => `${LIBRARY_NAME}@${LIBRARY_VERSION}`
